// React
import React from "react";

// Icons
import {
  FaFacebookF,
  FaInstagram,
  FaBehance,
  FaYoutube,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
import { HiOutlineShare } from "react-icons/hi";

// Share Buttons
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

// Styling
import styled from "styled-components";

// Utilities
import environment from "../../environment";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

export const Styles = styled.div`
  .icons-container {
    ${({ isAR }) => (!isAR ? "margin-left: 0px" : "margin-right: 0px")};
    display: flex;
    gap: ${({ bgColor }) => (bgColor === "transparent" ? "0.8rem" : "0")};
    .single-icon {
      background-color: ${({ bgColor }) => bgColor};
      margin: ${({ bgColor }) => (bgColor === "transparent" ? "0" : "0.2rem")};
      margin-top: 0;
      padding: ${({ bgColor }) => (bgColor === "transparent" ? "0" : "0 0.5rem")};
      border-radius: 100%;
    }
    a:last-child {
      .single-icon {
        ${({ isAR, bgColor }) =>
          bgColor === "transparent"
            ? ""
            : isAR
            ? "margin-left: 0; padding-left: 0;"
            : "margin-right: 0;padding-right: 0"};
      }
    }
    .single-icon:hover {
      background-color: ${({ bgColor }) => bgColor};
      opacity: 0.8;
    }
  }
  .share-container {
    .react-share__ShareButton {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      transition: all 0.3s ease;
      &:hover {
        opacity: 1;
      }
    }
    svg {
      width: 20px;
      height: 20px;
      margin: auto;
      display: block;
      path {
        fill: ${({ bgColor }) => bgColor};
      }
      circle {
        fill: transparent !important;
      }
    }
  }
`;

const SocialLinks = ({
  share,
  link,
  socialData,
  color,
  backgroundColor,
  loading,
  size = "1.2rem",
}) => {
  const currentUrl = window.location.href; // Get the current URL
  const { i18n } = useTranslation();

  // Function to return the appropriate icon for social media links
  // This function utilizes icons from the `react-icons` library and matches the item `name` to a specific icon.
  const getIcon = (name) => {
    switch (name) {
      case "FacebookLink":
        return <FaFacebookF size={size} color={color} />;
      case "InstagramLink":
        return <FaInstagram size={size} color={color} />;
      case "ThreadsLink":
        return <FaThreads size={size} color={color} />;
      case "XLink":
        return <FaXTwitter size={size} color={color} />;
      case "BehanceLink":
        return <FaBehance size={size} color={color} />;
      case "YoutubeLink":
        return <FaYoutube size={size} color={color} />;
      case "LinkedInLink":
        return <FaLinkedinIn size={size} color={color} />;
      case "TiktokLink":
        return <FaTiktok size={size} color={color} />;
      case "share":
        return <HiOutlineShare size={size} color={color} />;
      default:
        return null;
    }
  };
  // Function to return share buttons for social media platforms
  // Uses share containers provided by the `react-share` library to enable sharing functionality.
  const getShareIcon = (name) => {
    switch (name) {
      case "twitter":
        return (
          <TwitterShareButton url={link ? link : currentUrl}>
            <FaXTwitter color={color} round={true} />
          </TwitterShareButton>
        );

      case "youtube":
        return (
          <FacebookShareButton url={link ? link : currentUrl}>
            <FaYoutube color={color} round={true} />
          </FacebookShareButton>
        );
      case "linkedin":
        return (
          <LinkedinShareButton url={link ? link : currentUrl}>
            <FaLinkedinIn color={color} round={true} />
          </LinkedinShareButton>
        );
      case "facebook":
        return (
          <FacebookShareButton url={link ? link : currentUrl}>
            <FaFacebookF color={color} round={true} />
          </FacebookShareButton>
        );
      default:
        break;
    }
  };
  return (
    <Styles isAR={i18n?.language === "ar"} bgColor={backgroundColor}>
      <div className="icons-container">
        {!share ? (
          loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <Skeleton
                key={index}
                height={20}
                width={20}
                className="mx-1"
                style={{ margin: "0.2rem" }}
              />
            ))
          ) : (
            Object.keys(socialData).map(
              (key) =>
                socialData[key] &&
                getIcon(key) && (
                  <a
                    href={socialData[key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={key}
                  >
                    <div className="single-icon">{getIcon(key)}</div>
                  </a>
                )
            )
          )
        ) : (
          <div className="share-container">
            <div className="icons-container">
              {socialData?.map(
                (item, index) =>
                  // item?.link?.length > 0 && (
                    <div className="single-icon" key={index}>
                      {getShareIcon(item?.name)}
                    </div>
                  // )
              )}
            </div>
          </div>
        )}
      </div>
    </Styles>
  );
};

export default SocialLinks;
